import { EntityListProductInputData, EntityListSkuQuantityInputData } from '../entityListTypes';
import { EntityListItemConverter } from './EntityListItemConverter';
import { ImportedItemRow } from '../../../../../lib/imports/importTypes';

/**
 * Converts data containing product information to/from a structured format.
 */
export class EntityListProductItemConverter extends EntityListItemConverter<EntityListProductInputData> {
  convertFromStrings(cells: string[]): Partial<EntityListProductInputData> {
    const result: Partial<EntityListSkuQuantityInputData> = {};

    cells.forEach((cell, index) => {
      switch (index) {
        case 0:
          result.product = cell;
          break;
      }
    });

    return result;
  }

  convertToStructuredText(data: ImportedItemRow<EntityListProductInputData>[]): string {
    const parsedRowsFlat = data.map(row => `${row.inputData.product}`).join('\n');
    return `ProductIdentification\n${parsedRowsFlat}`;
  }
}
